import { useState } from "react";
import { Stack } from "@altimateai/lego";
import { DbtCloudConnectionResponse } from "../../types";
import { ConnectionCard } from "./ConnectionCard";
import { DetailsCard } from "./DetailsCard";
import { EditConnectionDialog } from "./EditConnectionDialog";
import { DeleteConnectionDialog } from "./DeleteConnectionDialog";

interface DbtCloudConnectionProps {
  connection: DbtCloudConnectionResponse;
  syncOpAllowed: boolean;
}

const DbtCloudConnection = ({ connection, syncOpAllowed }: DbtCloudConnectionProps): JSX.Element => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  return (
    <>
      <Stack className="al-grid al-grid-cols-[2fr_3fr] al-gap-6 al-w-full al-mt-6">
        <ConnectionCard
          connection={connection}
          syncOpAllowed={syncOpAllowed}
          onEdit={() => setIsEditOpen(true)}
          onDelete={() => setIsDeleteOpen(true)}
        />
        <DetailsCard connection={connection} />
      </Stack>

      <EditConnectionDialog
        connection={connection}
        open={isEditOpen}
        onOpenChange={setIsEditOpen}
      />

      <DeleteConnectionDialog
        connection={connection}
        open={isDeleteOpen}
        onOpenChange={setIsDeleteOpen}
      />
    </>
  );
};

export default DbtCloudConnection;
